// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import Navbar from "./components/PremiumNavbar";
// import Footer from "./components/Footer";

// import Home from "./pages/Home";
// import About from "./pages/About";
// import Process from "./pages/Process";
// import Compliance from "./pages/Compliance";
// import Contact from "./pages/Contact";
// import AdminLogin from "./pages/admin/AdminLogin";
// import AdminDashboard from "./pages/admin/AdminDashboard";
// import RequireAuth from "./components/RequireAuth";
// import ComplianceCMS from "./pages/admin/ComplianceCMS";
// export default function App() {
//   return (
//     <div className="min-h-screen flex flex-col bg-white text-slate-800">
//       <Navbar />
//       <main className="flex-1">
//         <div className="max-w-7xl mx-auto px-6 py-10">
//           <Routes>
//             <Route path="/" element={<Home />} />
//             <Route path="/about" element={<About />} />
//             <Route path="/process" element={<Process />} />
//             <Route path="/compliance" element={<Compliance />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/admin/login" element={<AdminLogin />} />
//             <Route path="/admin" element={<RequireAuth><AdminDashboard/></RequireAuth>}/>
//             <Route path="/admin/compliance" element={<RequireAuth><ComplianceCMS /></RequireAuth>}/>

//           </Routes>
//         </div>
//       </main>
//       <Footer />
//     </div>
//   );
// }

// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import Navbar from "./components/PremiumNavbar";
// import Footer from "./components/Footer";

// import Home from "./pages/Home";
// import About from "./pages/About";
// import Process from "./pages/Process";
// import Compliance from "./pages/Compliance";
// import Contact from "./pages/Contact";

// import AdminLogin from "./pages/admin/AdminLogin";
// import RequireAuth from "./components/RequireAuth";

// // NEW Admin Layout + Pages
// import AdminLayout from "./pages/admin/layout/AdminLayout";
// import ComplianceCMS from "./pages/admin/ComplianceCMS";
// import BlogsCMS from "./pages/admin/blogs/BlogsCMS";
// import TestimonialsCMS from "./pages/admin/testimonials/TestimonialsCMS";
// import Blogs from "./pages/Blogs";
// import BlogDetails from "./pages/BlogDetails";
// import AccessibilityButton from "./components/AccessibilityButton";
// import { AccessibilityProvider } from "./components/AccessibilityContext";
// export default function App() {
//   return (
//     <Routes>
//       {/* ⭐ PUBLIC FRONTEND ROUTES WITH NAV+FOOTER ⭐ */}
//       <Route
//         path="/"
//         element={
//           <Layout>
//             <Home />
//           </Layout>
//         }
//       />
//       <Route
//         path="/about"
//         element={
//           <Layout>
//             <About />
//           </Layout>
//         }
//       />
//       <Route
//         path="/process"
//         element={
//           <Layout>
//             <Process />
//           </Layout>
//         }
//       />
//       <Route
//         path="/compliance"
//         element={
//           <Layout>
//             <Compliance />
//           </Layout>
//         }
//       />
//       <Route
//         path="/contact"
//         element={
//           <Layout>
//             <Contact />
//           </Layout>
//         }
//       />
//       <Route
//         path="/blogs"
//         element={
//           <Layout>
//             <Blogs />
//           </Layout>
//         }
//       />
//       <Route
//         path="/blog/:slug"
//         element={
//           <Layout>
//             <BlogDetails />
//           </Layout>
//         }
//       />

//       {/* ⭐ ADMIN LOGIN PAGE (NO NAV/FOOTER) ⭐ */}
//       <Route path="/admin/login" element={<AdminLogin />} />

//       {/* ⭐ PROTECTED ADMIN PANEL ⭐ */}
//       <Route
//         path="/admin"
//         element={
//           <RequireAuth>
//             <AdminLayout />
//           </RequireAuth>
//         }
//       >
//         {/* <Route index element={<DashboardHome />} /> */}
//         <Route path="compliance" element={<ComplianceCMS />} />
//         <Route path="blogs" element={<BlogsCMS />} />
//         <Route path="testimonials" element={<TestimonialsCMS />} />
//       </Route>
//     </Routes>
//   );
// }

// /* 🔹 Common Layout Wrapper for Public Pages */
// function Layout({ children }) {
//   return (
//     <AccessibilityProvider>
//       <div className="min-h-screen flex flex-col bg-white text-slate-800">
//         <Navbar />

//         <main className="flex-1">
//           <div className="max-w-7xl mx-auto px-6 py-10">{children}</div>
//         </main>
//         <AccessibilityButton />
//         <Footer />
//       </div>
//     </AccessibilityProvider>
//   );
// }

import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/PremiumNavbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Process from "./pages/Process";
import Compliance from "./pages/Compliance";
import Contact from "./pages/Contact";

import AdminLogin from "./pages/admin/AdminLogin";
import RequireAuth from "./components/RequireAuth";

import AdminLayout from "./pages/admin/layout/AdminLayout";
import ComplianceCMS from "./pages/admin/ComplianceCMS";
import BlogsCMS from "./pages/admin/blogs/BlogsCMS";
import TestimonialsCMS from "./pages/admin/testimonials/TestimonialsCMS";
import Blogs from "./pages/Blogs";
import BlogDetails from "./pages/BlogDetails";

/* Skip link handler: move keyboard focus into <main> (WCAG 2.4.1 Bypass Blocks) */
function skipToMain(e) {
  const main = document.getElementById("main-content");
  if (!main) return;
  e.preventDefault();
  main.focus();
  main.scrollIntoView();
}

export default function App() {
  return (
      // <AccessibilityProvider>
      //   <AccessibilityOverlay />
      <div className="min-h-screen flex flex-col bg-white text-slate-800">
        {/* First focusable element on every page: skip link (WCAG 2.4.1) */}
        <a href="#main-content" className="skip-link" onClick={skipToMain}>
          Skip to main content
        </a>
        <Navbar />
        {/* <AccessibilityButton /> */}
        <main id="main-content" tabIndex={-1} className="flex-1 a11y-readable read-area">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/process" element={<Process />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:slug" element={<BlogDetails />} />

            <Route path="/admin/login" element={<AdminLogin />} />

            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route path="compliance" element={<ComplianceCMS />} />
              <Route path="blogs" element={<BlogsCMS />} />
              <Route path="testimonials" element={<TestimonialsCMS />} />
            </Route>
          </Routes>
        </main>
        <Footer />
      </div>
        // </AccessibilityProvider>
  );
}
